import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../constants/common'
import { ICON_HEIGHT_72, IconNG } from '../../Icon'
import TextComponent from '../../Text'

import * as styles from './SearchEmpty.module.css'

import SearchIcon from '../../../icons/search.svg'

/**
 * @typedef {object} SearchEmptyTextProps
 *
 * @property {string} [className]
 *
 * @property {React.ReactNode} [children]
 *
 * @property {boolean} [isSecondary]
 */

/**
 * @typedef {object} SearchEmptyProps
 *
 * @property {string} [Element]
 *
 * @property {React.ComponentType<SVGProps>} [Icon]
 *
 * @property {React.ComponentType<SearchEmptyTextProps>} [Text]
 *
 * @property {string} [className]
 *
 * @property {SVGProps} [iconProps]
 *
 * @property {string} [text]
 *
 * @property {SearchEmptyTextProps} [textProps]
 */

/**
 * @param {SearchEmptyProps} props
 */
function SearchEmpty({
  Element = 'div',
  Icon = SearchIcon,
  Text = TextComponent,
  className = styles.SearchEmpty,
  iconProps: {
    className: iconClassName = styles.icon,
    ...iconProps
  } = EMPTY_OBJECT,
  text = 'Search.NoDataKey',
  textProps: {
    className: textClassName = styles.text,
    isSecondary: isSecondaryText = true,
    ...textProps
  } = EMPTY_OBJECT,
  ...elementProps
}) {
  const { t } = useTranslation()

  return (
    <Element {...elementProps} className={className}>
      <IconNG
        {...iconProps}
        Icon={Icon}
        className={iconClassName}
        size={ICON_HEIGHT_72}
      />
      <Text
        {...textProps}
        className={textClassName}
        isSecondary={isSecondaryText}
      >
        {t(text)}
      </Text>
    </Element>
  )
}

export default SearchEmpty
